import React, { FC, useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { LangValue } from '../../../../states/types/common'
import { format, nowDate } from '../../../../utils/date'
import { getGetPrams, setPath, setUrlParam } from '../../../../utils/url'
import { URL } from '../../../constants/url'
import DateCalendarModule from '../../../components/task/DateCalendarModule'
import { uniqueId } from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../states/containers/store'
import { RequestGetTaskLabelingStatus } from '../../../../states/types/task'
import {
  destroyTaskManual,
  fetchTaskLabelingStatus,
  updateTaskCompanyServiceName,
} from '../../../../states/containers/task/taskSlice'
import ConfirmationModal from '../../../components/task/ConfirmationModal'
import LoadingSquare from '../../../components/common/LoadingSquare'
import SearchConditionModule from '../../../components/task/SearchConditionModule'
import LabelingStatusModule from '../../../components/task/LabelingStatusModule'
import { updateCurrentDate, updateTaskStatusListView } from '../../../../states/containers/common/currentSlice'
import { useAlert } from 'react-alert'
import Tips from '../../../components/common/Tips'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import VideoGuide from '../../../components/common/VideoGuide'
import SearchConditionModuleForHighVolume from '../../../components/task/SearchConditionModuleForHighVolume'

interface ConfirmationModalState {
  display: boolean
  type: string
  name: string
  callback: VoidFunction
}

interface GetParams {
  date: string
  team_ids: string
  member_ids: string
  label_group_ids: string
}

interface MemberData {
  member_id: number
  member_name: string
  summary: {
    labeling: number
    not_labeling: number
    not_covered: number
  }
  task_type: {
    auto: number
    manual: number
  }
  labeling_status: {
    auto: {
      labeling: number
      not_labeling: number
    }
    manual: {
      labeling: number
      not_labeling: number
    }
  }
  labeling_method: {
    auto: number
    manual: number
  }
  not_covered_services: {
    display_name: string // Qasee全体での名前
    labeling_target: boolean // 仕分け対象ならtrue
    time: number // 使用時間(秒)
    company_service_name_ids: number[]
  }[]
  manual_tasks: {
    task_id: number
    time: number
    task_name: string | null
    start_time: string
    end_time: string
    included_untargeted_services: {
      service_name: string
      icon: string | null
      icon_color: string | null
      time: number
    }[]
    label: {
      label_group_id: number
      label_group_name: string
      label_group_color: string
      label_id: number
      label_name: string
      label_color: string
      disabled: boolean
      status: 'manual' | 'auto' | 'suggestion' | 'repeat_suggestion' | 'suggestion_accepted' | 'repeat'
    } | null
  }[]
}

const Index: FC = () => {
  const {
    task,
    current,
    login,
  } = useSelector((state: RootState) => state)

  const DISPLAY_LIMIT = 9

  const { language } = useParams<{ language: LangValue }>()
  const location = useLocation()
  const history = useHistory()
  const alert = useAlert()
  const dispatch = useDispatch()

  const [pageOffset, setPageOffset] = useState<number>(1)
  const [date, setDate] = useState<string>("")
  const [data, setData] = useState<MemberData[]>([])

  const [selectTeamIds, setSelectTeamIds] = useState<number[]>([])
  const [selectMemberIds, setSelectMemberIds] = useState<number[]>([])
  const [selectLabelGroupIds, setSelectLabelGroupIds] = useState<number[]>([])

  const [isFirst, setIsFirst] = useState<boolean>(true)

  const [isDisplayDetail, setIsDisplayDetail] = useState<boolean>(false)

  const [isDataLoad, setIsDataLoad] = useState<boolean>(false)

  const [isLoadingFirst, setIsLoadingFirst] = useState<boolean>(true)
  const [isLoadingMember, setIsLoadingMember] = useState<boolean>(true)

  const [isDisplaySticky, setIsDisplaySticky] = useState(false)

  const [confirmationModalState, setConfirmationModalState] = useState<ConfirmationModalState>({
    display: false,
    type: "",
    name: "",
    callback: () => {
      // none
    },
  })

  const clickRow = (id: number) => {
    history.push(`${setPath(setUrlParam(
      URL.TASK_LABELING.path,
      [
        { key: 'id', value: id.toString() },
      ],
    ), language)}?date=${format(date, "YYYY-MM-DD")}`)
  }

  const closeConfirmationModal = () => {
    setConfirmationModalState({
      ...confirmationModalState,
      display: false,
      type: "",
      name: "",
      callback: () => {
        // none
      },
    })
  }

  const currentScroll = () => Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop)
  const bottomHeight = () => document.getElementsByClassName("main")[0].clientHeight
  const windowHeight = () => document.documentElement.clientHeight

  const scrollTop = (): number => Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop)

  const onScroll = () => {
    const adjustment = window.innerWidth >= 1280 ? 0.90 : 0.85
    if ((bottomHeight() * adjustment) < (currentScroll() + windowHeight())) {
      setIsDataLoad(true)
    }
    if (scrollTop() <= 400) {
      setIsDisplaySticky(false)
    } else {
      setIsDisplaySticky(true)
    }
  }

  const delTask = (memberId: number, taskId: number) => {
    setConfirmationModalState({
      ...confirmationModalState,
      display: true,
      type: "delete",
      name: data.find((v) => v.member_id === memberId)?.manual_tasks.find((w) => w.task_id === taskId)?.task_name || "",
      callback: () => {
        dispatch(
          destroyTaskManual(
            { id: taskId },
            () => {
              setData(
                data.map((v) => {
                  if (v.member_id === memberId) {
                    const tmp = v.manual_tasks.find((w) => w.task_id === taskId)
                    if (!tmp) return v
                    if (tmp?.label?.label_id) {
                      return {
                        ...v,
                        summary: {
                          ...v.summary,
                          labeling: v.summary.labeling - tmp.time,
                        },
                        labeling_status: {
                          ...v.labeling_status,
                          manual: {
                            ...v.labeling_status.manual,
                            labeling: v.labeling_status.manual.labeling - tmp.time,
                          },
                        },
                        manual_tasks: v.manual_tasks.filter((w) => w.task_id !== taskId),
                      }
                    }
                    return {
                      ...v,
                      summary: {
                        ...v.summary,
                        not_labeling: v.summary.not_labeling - tmp.time,
                      },
                      labeling_status: {
                        ...v.labeling_status,
                        manual: {
                          ...v.labeling_status.manual,
                          not_labeling: v.labeling_status.manual.not_labeling - tmp.time,
                        },
                      },
                      manual_tasks: v.manual_tasks.filter((w) => w.task_id !== taskId),
                    }
                  }
                  return v
                }),
              )
              alert.success("作業データを削除しました")
            },
          ),
        )
      },
    })
  }

  // lite list
  const [isDisplayLiteList, setIsDisplayLiteList] = useState(false)

  const toggleListView = () => {
    dispatch(updateTaskStatusListView(!isDisplayLiteList))
    setIsDisplayLiteList(!isDisplayLiteList)
  }

  const ctrlPlusKeyFunction = useCallback((event: KeyboardEvent) => {
    // 「Ctrl + L」キーでリスト表示
    if (event.ctrlKey && event.key === "l") {
      setIsDisplayLiteList(true)
      dispatch(updateTaskStatusListView(true))
    }
    // 「Ctrl + B」キーでブロック表示
    if (event.ctrlKey && event.key === "b") {
      setIsDisplayLiteList(false)
      dispatch(updateTaskStatusListView(false))
    }
  }, [])

  const toggleLabelingTarget = (companyServiceName: string, companyServiceNameIds: number[], isTarget: boolean) => {
    dispatch(
      updateTaskCompanyServiceName(
        {
          company_service_name_ids: companyServiceNameIds,
          labeling_target: isTarget,
        },
        () => {
          alert.success("設定を変更しました")
          setData(
            data.map((v) => (
              {
                ...v,
                not_covered_services: v.not_covered_services.map((w) => {
                  if (w.display_name === companyServiceName) {
                    return { ...w, labeling_target: true }
                  }
                  return w
                }),
              }
            )),
          )
        },
      ),
    )
  }

  useEffect(() => {
    document.addEventListener("scroll", onScroll)
    document.addEventListener("keydown", ctrlPlusKeyFunction)
    return () => {
      document.removeEventListener("scroll", onScroll)
      document.removeEventListener("keydown", ctrlPlusKeyFunction)
    }
  }, [])

  useEffect(() => {
    if (!isDataLoad || pageOffset >= (task.taskLabelingStatus?.page_count || 1)) return
    setPageOffset(pageOffset + 1)
    setIsLoadingMember(true)
  }, [isDataLoad])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  useEffect(() => {
    const getParams = getGetPrams(location.search) as GetParams
    if (getParams.date) {
      setDate(format(getParams.date, "YYYY-MM-DD"))
    } else {
      setDate(format(current.targetDate, "YYYY-MM-DD") || nowDate("YYYY-MM-DD"))
    }
    if (getParams.team_ids) {
      setSelectTeamIds(getParams.team_ids.split(',').map((v) => Number(v)) || [])
    }
    if (getParams.member_ids) {
      setSelectMemberIds(getParams.member_ids.split(',').map((v) => Number(v)) || [])
    }
    if (getParams.label_group_ids) {
      setSelectLabelGroupIds(getParams.label_group_ids.split(',').map((v) => Number(v)) || [])
    }
  }, [])

  useEffect(() => {
    if (!task.taskLabelingStatus?.data) return
    setData([...data, ...task.taskLabelingStatus.data])
  }, [task.taskLabelingStatus?.data])

  useEffect(() => {
    if (isFirst) {
      setIsFirst(false)
      return
    }
    const query = []
    const params: RequestGetTaskLabelingStatus = {
      target_date: date,
      page: 1,
      limit: DISPLAY_LIMIT,
    }
    setPageOffset(1)
    setData([])
    setIsLoadingFirst(true)
    if (date) {
      query.push(`date=${format(date, "YYYY-MM-DD")}`)
    }
    if (selectTeamIds.length) {
      params.team_ids = selectTeamIds
      query.push(`team_ids=${selectTeamIds.join(",")}`)
    }
    if (selectMemberIds.length) {
      params.member_ids = selectMemberIds
      query.push(`member_ids=${selectMemberIds.join(",")}`)
    }
    if (selectLabelGroupIds.length) {
      params.label_group_ids = selectLabelGroupIds
      query.push(`label_group_ids=${selectLabelGroupIds.join(",")}`)
    }
    dispatch(fetchTaskLabelingStatus(
      params,
      () => {
        setIsLoadingFirst(false)
        setIsDataLoad(false)
      },
    ))
    history.push(`${setPath(URL.TASK_LABELING_STATUS.path, language)}?${query.join('&')}`)
  }, [selectTeamIds, selectMemberIds, selectLabelGroupIds, date])

  useEffect(() => {
    if (pageOffset === 1 || pageOffset > (task.taskLabelingStatus?.page_count || 1)) {
      setIsDataLoad(false)
      setIsLoadingMember(false)
      return
    }
    const params: RequestGetTaskLabelingStatus = {
      target_date: date,
      page: pageOffset,
      limit: DISPLAY_LIMIT,
    }
    if (selectTeamIds.length) {
      params.team_ids = selectTeamIds
    }
    if (selectMemberIds.length) {
      params.member_ids = selectMemberIds
    }
    if (selectLabelGroupIds.length) {
      params.label_group_ids = selectLabelGroupIds
    }
    dispatch(fetchTaskLabelingStatus(
      params,
      () => {
        setIsDataLoad(false)
        setIsLoadingMember(false)
      },
    ))
  }, [pageOffset])

  useEffect(() => {
    setIsDisplayLiteList(current.taskStatusListView)
  }, [current.taskStatusListView])

  return (
    <>
      <section className="task_page">
        <Helmet>
          <title>Qasee - 工数管理 - 仕分け状況</title>
        </Helmet>
        <section className="breadcrumb">
          工数管理
          &nbsp;&gt;&nbsp;
          仕分け状況
          &nbsp;
        </section>
        <section className="page_header">
          <h1>
            仕分け状況
            <VideoGuide
              videoId="889TM0qmVpQ"
            />
          </h1>
          <div className="tools">
            <DateCalendarModule
              date={date}
              changeCallback={(callback_date) => {
                setDate(callback_date)
                dispatch(updateCurrentDate(callback_date))
              }}
              disabled={isLoadingFirst || isLoadingMember}
            />
          </div>
        </section>
        <section className="page_description">
          <p>
            各メンバーの1日ごとの業務仕分け状況を一覧で表示しています。
          </p>
          <p>
            仕分け対象アプリ設定が適切か、また、業務仕分けが適切におこなわれているか確認しましょう。
          </p>
        </section>
        {
          login.permissions?.high_volume ? (
            <SearchConditionModuleForHighVolume
              name=""
              callbackTeamIds={setSelectTeamIds}
              teamList={task.taskLabelingStatus?.teams.map((v) => ({ id: v.id, name: v.name }))}
              callbackMemberIds={setSelectMemberIds}
              memberList={task.taskLabelingStatus?.members.map((v) => ({ id: v.id, name: v.name }))}
              callbackLabelGroupIds={setSelectLabelGroupIds}
              labelGroupList={task.taskLabelingStatus?.label_groups.map((v) => ({ id: v.id, name: v.name }))}
            />
          ) : (
            <SearchConditionModule
              name=""
              teamIds={selectTeamIds}
              callbackTeamIds={setSelectTeamIds}
              teamList={task.taskLabelingStatus?.teams.map((v) => ({ id: v.id, name: v.name }))}
              memberIds={selectMemberIds}
              callbackMemberIds={setSelectMemberIds}
              memberList={task.taskLabelingStatus?.members.map((v) => ({ id: v.id, name: v.name }))}
              labelGroupIds={selectLabelGroupIds}
              callbackLabelGroupIds={setSelectLabelGroupIds}
              labelGroupList={task.taskLabelingStatus?.label_groups.map((v) => ({ id: v.id, name: v.name }))}
            />
          )
        }
        {
          isLoadingFirst ? (
            <section className="page_contents content-area">
              <div className="content-block">
                <LoadingSquare>
                  <>
                    業務仕分け状況データを集計しています…
                  </>
                </LoadingSquare>
              </div>
            </section>
          ) : (
            <>
              <section className="page_contents content-area" key={uniqueId()}>
                <div className="content-block">
                  <div className="block-header">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <div
                        style={{
                          display: "inline-block",
                          position: "relative",
                          fontSize: "16px",
                        }}
                      >
                        仕分け状況
                      </div>
                      <div>
                        {
                          isDisplayLiteList ? (
                            <>
                              <Tips
                                description="ブロック表示に切り替えます"
                                className=""
                                icon={false}
                              >
                                <>
                                  <button
                                    type="button"
                                    onClick={toggleListView}
                                    style={{
                                      border: "solid 1px #CCC",
                                      borderRadius: "4px",
                                      padding: "4px 6px",
                                      display: "flex",
                                      gap: "4px",
                                    }}
                                  >
                                    <FontAwesomeIcon icon={['fas', 'list']} />
                                    <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                                    <FontAwesomeIcon icon={['fas', 'chart-pie']} />
                                  </button>
                                </>
                              </Tips>
                            </>
                          ) : (
                            <>
                              <Tips
                                description="リスト表示に切り替えます"
                                className=""
                                icon={false}
                              >
                                <>
                                  <button
                                    type="button"
                                    onClick={toggleListView}
                                    style={{
                                      border: "solid 1px #CCC",
                                      borderRadius: "4px",
                                      padding: "4px 6px",
                                      display: "flex",
                                      gap: "4px",
                                    }}
                                  >
                                    <FontAwesomeIcon icon={['fas', 'chart-pie']} />
                                    <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                                    <FontAwesomeIcon icon={['fas', 'list']} />
                                  </button>
                                </>
                              </Tips>
                            </>
                          )
                        }
                      </div>
                    </div>
                    {
                      !isDisplayLiteList && (
                        <>
                          <div className="tools">
                            <button
                              type="button"
                              className={`display_switch labeling_status ${isDisplayDetail ? "" : "check"} ${isDisplaySticky ? "sticky" : ""}`}
                              onClick={() => setIsDisplayDetail(!isDisplayDetail)}
                            >
                              <div>
                                <span>
                                  サマリーを表示
                                </span>
                              </div>
                              <div>
                                <span>
                                  内訳を表示
                                </span>
                              </div>
                            </button>
                          </div>
                        </>
                      )
                    }
                  </div>
                  <div
                    style={{
                      border: "solid 1px #CCCCCC",
                      borderRadius: "4px",
                      marginBottom: "16px",
                      display: "flex",
                      flexFlow: "column",
                      gap: "4px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        borderBottom: "solid 1px #CCCCCC",
                        padding: "4px 8px",
                        backgroundColor: "#EEEEEE",
                        borderRadius: "4px 4px 0 0",
                      }}
                    >
                      <FontAwesomeIcon icon={['fas', 'lightbulb']} style={{ color: "#d9c010" }} />
                      表示できるメンバー
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexFlow: "column",
                        gap: "2px",
                        padding: "8px",
                      }}
                    >
                      <div>
                        {
                          login.permissions?.high_volume ? (
                            <>
                              あなたが表示できるプロジェクトの参加メンバーが表示されています
                            </>
                          ) : (
                            <>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  flexWrap: "wrap",
                                }}
                              >
                                プロジェクト：
                                {
                                  task.taskLabelingStatus?.label_groups.map((v) => (
                                    <div
                                      style={{
                                        padding: "2px 4px",
                                        border: "solid 1px #CCCCCC",
                                        borderRadius: "4px",
                                        fontSize: "11px",
                                      }}
                                    >
                                      {v.name}
                                    </div>
                                  ))
                                }
                                の参加メンバー
                              </div>
                            </>
                          )
                        }
                      </div>
                    </div>
                  </div>
                  <div className="block-detail">
                    {
                      isDisplayLiteList ? (
                        <>
                          <div className="task_status_list_area">
                            {
                              data?.map((member) => (
                                <LabelingStatusModule
                                  member={member}
                                  memberClickCallback={(memberId) => clickRow(memberId)}
                                  addCallback={(serviceName, targetIds) => toggleLabelingTarget(serviceName, targetIds, true)}
                                  isDisplayDetail={isDisplayDetail}
                                  date={date}
                                  delTaskCallback={(memberId, taskId) => delTask(memberId, taskId)}
                                  isDisplayLiteList={isDisplayLiteList}
                                  key={uniqueId()}
                                />
                              ))
                            }
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="task_status_card_area">
                            {
                              (!data.length) && (
                                <div>
                                  データがありません
                                </div>
                              )
                            }
                            {
                              data?.map((member) => (
                                <LabelingStatusModule
                                  member={member}
                                  memberClickCallback={(memberId) => clickRow(memberId)}
                                  addCallback={(serviceName, targetIds) => toggleLabelingTarget(serviceName, targetIds, true)}
                                  isDisplayDetail={isDisplayDetail}
                                  date={date}
                                  delTaskCallback={(memberId, taskId) => delTask(memberId, taskId)}
                                  isDisplayLiteList={isDisplayLiteList}
                                  key={uniqueId()}
                                />
                              ))
                            }
                          </div>
                        </>
                      )
                    }
                  </div>
                  {
                    isLoadingMember ? (
                      <div className="block-detail">
                        <LoadingSquare>
                          <>
                            仕分け状況データを読み込み中…
                          </>
                        </LoadingSquare>
                      </div>
                    ) : (
                      <>
                        {
                          pageOffset < (task.taskLabelingStatus?.page_count || 1) && (
                            <div className="more_button_area">
                              <button
                                type="button"
                                onClick={() => setIsDataLoad(true)}
                              >
                                続きを見る
                              </button>
                            </div>
                          )
                        }
                      </>
                    )
                  }
                </div>
              </section>
            </>
          )
        }
        {/* 確認モーダル */}
        <ConfirmationModal
          confirmationModalState={confirmationModalState}
          closeCallback={closeConfirmationModal}
        />
      </section>
    </>
  )
}

export default Index
